<template>
  <div class="signin-page-container">
    <div class="container d-flex align-items-center justify-content-center min-vh-100 py-5">
      <div class="login-card shadow-premium" id="containLoader" ref="containLoader">
        <!-- Left Panel: Brand & CamDigiKey Info -->
        <div class="brand-panel">
          <div class="brand-panel-overlay"></div>
          <div class="brand-panel-content">
            <router-link :to="{ name: 'Home' }" class="brand-logo-link">
              <img
                class="brand-logo img-fluid animate-logo"
                alt="SECC Logo"
                src="../../assets/secclogo.png"
              />
            </router-link>
            <h3 class="welcome-title font-moul">{{ $t("message.welcome") }}</h3>
            <p class="welcome-subtitle">{{ $t("message.welcome_training") }}</p>
            <p class="welcome-text">{{ $t("message.keep_connection") }}</p>

            <div class="camdigikey-info-box">
              <span class="support-label">{{ $t("message.support_with") }}</span>
              <a href="https://camdigikey.gov.kh/" target="_blank" class="camdigikey-logo-link">
                <img src="@/assets/images/unnamed.webp" class="camdigikey-badge-img" alt="CamDigiKey" />
              </a>
              <div class="download-apps-section w-100">
                <p class="download-label text-center">{{ $t("message.download_app") }}</p>
                <div class="download-links justify-content-center">
                  <a
                    href="https://play.google.com/store/apps/details?id=kh.gov.camdx.camdigikey"
                    target="_blank"
                    class="btn-download btn-android text-white"
                  >
                    <i class="fab fa-android"></i> ANDROID
                  </a>
                  <a
                    href="https://apps.apple.com/kh/app/camdigikey/id1509386989"
                    target="_blank"
                    class="btn-download btn-ios text-white"
                  >
                    <i class="fab fa-apple"></i> iOS
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Panel: Standard Credentials Form -->
        <div class="form-panel">
          <div class="form-panel-content">
            <div class="icon-header-badge animate-bounce-subtle">
              <i class="fa fa-graduation-cap"></i>
            </div>
            
            <h4 class="form-title text-center mb-4">{{ $t("message.login") }}</h4>

            <form @submit.prevent>
              <!-- Email Input -->
              <div class="form-group-custom">
                <label class="form-label-custom">{{ $t("message.email") }}</label>
                <div class="input-wrapper">
                  <i class="fas fa-envelope input-icon"></i>
                  <input
                    type="text"
                    class="form-control-custom"
                    v-model.trim="loginform.email"
                    :class="{ 'is-invalid': v$.loginform.email.$error }"
                    placeholder="example@mail.com"
                  />
                </div>
              </div>

              <!-- Password Input -->
              <div class="form-group-custom">
                <label class="form-label-custom">{{ $t("message.password") }}</label>
                <div class="input-wrapper">
                  <i class="fas fa-lock input-icon"></i>
                  <input
                    type="password"
                    class="form-control-custom"
                    v-model.trim="loginform.password"
                    :class="{ 'is-invalid': v$.loginform.password.$error }"
                    placeholder="••••••••"
                  />
                </div>
              </div>

              <!-- Forget Password -->
              <div class="forget-password-wrapper">
                <router-link :to="{ name: 'ForgetPassword' }" class="forget-password-link">
                  {{ $t("message.forgot_password") }}?
                </router-link>
              </div>

              <!-- Login Buttons -->
              <div class="form-actions mt-4">
                <button
                  type="button"
                  class="btn-premium-signin"
                  @click="singin"
                >
                  <span>{{ $t("message.singin") }}</span>
                  <i class="fas fa-sign-in-alt"></i>
                </button>
              </div>

              <div class="separator-or">
                <span>{{ $t("message.or") }}</span>
              </div>

              <!-- CamDigiKey Login Button -->
              <div class="camdigikey-action">
                <button
                  type="button"
                  class="btn-camdigikey-signin"
                  @click.prevent="getCamDigikey"
                >
                  <img src="@/assets/images/unnamed.webp" class="btn-cam-img" alt="" />
                  <span>{{ $t("message.signin_camdigikey") }}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from "@/axios";

export default {
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      loginform: {
        email: "",
        password: ""
      }
    };
  },
  validations() {
    return {
      loginform: {
        email: { required, $autoDirty: true },
        password: { required, $autoDirty: true }
      }
    };
  },
  methods: {
    showLoader() {
      return this.$loading.show({
        // Optional parameters
        container: this.$refs.containLoader,
        color: "#01B201",
        canCancel: true,
        onCancel: this.onCancelLoader
      });
    },
    async singin() {
      let loader = this.showLoader();
      try {
        const response = await this.$store.dispatch("act_login", {
          data: this.loginform,
          toast: this.$toast
        });

        if (response.success) {
          loader.hide();
          if (this.$store.getters.getAuthRole[0] === 'user') {
            this.$router.push({ name: "Home" });
          } else if (this.$store.getters.getAuthRole[0] === 'supperAdmin' || this.$store.getters.getAuthRole[0] === 'Admin') {
            this.$router.push({ name: "adminNewRegistor" });
          } else if (this.$store.getters.getAuthRole[0] === 'Account') {
            this.$router.push({ name: "invoiceManagement" });
          }
        } else {
          loader.hide();
          this.$toast.open({
            message: "Login fail " + response.message,
            type: "error",
            duration: 5000,
            dismissible: true,
            position: "top-right"
          });
        }
      } catch (error) {
        loader.hide();
      }
    },
    async getCamDigikey() {
      let loader = this.showLoader();
      try {
        let response = await axios.post("get-camdigikey");
        if (response.data.status) {
          loader.hide();
          window.location.href = response.data.response.loginUrl;
        } else {
          loader.hide();
          this.$toast.open({
            message: "Login fail " + response.message,
            type: "error",
            duration: 5000,
            dismissible: true,
            position: "top-right"
          });
        }
      } catch (error) {
        loader.hide();
      }
    }
  }
};
</script>

<style scoped>
.signin-page-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #0e8937 0%, #05170d 100%);
  font-family: 'Battambang', 'Inter', sans-serif;
}

/* Login Card Layout */
.login-card {
  display: flex;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 950px;
  min-height: 580px;
}

/* Left Brand Panel */
.brand-panel {
  position: relative;
  flex: 1;
  background: url("~@/assets/images/bg.jpg") no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #ffffff;
}

.brand-panel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(9, 26, 16, 0.65) 0%,
    rgba(5, 12, 8, 0.78) 100%
  );
  z-index: 1;
}

.brand-panel-content {
  position: relative;
  z-index: 2;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.brand-logo-link {
  display: inline-block;
  margin-bottom: 24px;
}

.brand-logo {
  width: 110px;
  height: auto;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.brand-logo:hover {
  transform: rotate(-3deg) scale(1.08);
}

.welcome-title {
  font-family: 'Moul', 'Khmer Moul', cursive;
  font-size: 1.6rem;
  color: #ffc107;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(255, 193, 7, 0.2);
}

.welcome-subtitle {
  font-size: 1.05rem;
  font-weight: 500;
  margin-bottom: 12px;
  color: #ffffff;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.8);
}

.welcome-text {
  font-size: 0.88rem;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 30px;
  max-width: 280px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
}

/* CamDigiKey download section */
.camdigikey-info-box {
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.support-label {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 12px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
}

.camdigikey-badge-img {
  width: 75px;
  border-radius: 10px;
  transition: transform 0.2s;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  margin-bottom: 20px;
}

.camdigikey-badge-img:hover {
  transform: scale(1.05);
}

.download-apps-section {
  margin-top: 10px;
}

.download-label {
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 12px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
}

.download-links {
  display: flex;
  gap: 12px;
}

.btn-download {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  padding: 8px 16px;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 30px;
  text-decoration: none;
  transition: all 0.2s;
}

.btn-download:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-1px);
}

.btn-android:hover {
  border-color: #3ddc84;
  box-shadow: 0 0 10px rgba(61, 220, 132, 0.2);
}

.btn-ios:hover {
  border-color: #ffffff;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
}

/* Right Form Panel */
.form-panel {
  flex: 1.2;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
}

.form-panel-content {
  width: 100%;
  max-width: 380px;
}

.icon-header-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  background: rgba(14, 137, 55, 0.08);
  border-radius: 50%;
  color: #0e8937;
  font-size: 26px;
  margin: 0 auto 20px auto;
  border: 1px solid rgba(14, 137, 55, 0.15);
}

.form-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e35;
}

/* Custom Input Controls */
.form-group-custom {
  margin-bottom: 20px;
}

.form-label-custom {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #4a5c50;
  margin-bottom: 6px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 14px;
  color: #8c9c90;
  font-size: 0.95rem;
}

.form-control-custom {
  width: 100%;
  padding: 12px 16px 12px 42px;
  background: #f4f5f7;
  border: 1.5px solid #edf0f2;
  border-radius: 10px;
  font-size: 0.95rem;
  color: #2c3e35;
  transition: all 0.25s ease;
}

.form-control-custom:focus {
  background: #ffffff;
  border-color: #0e8937;
  outline: none;
  box-shadow: 0 0 0 3px rgba(14, 137, 55, 0.1);
}

.form-control-custom.is-invalid {
  border-color: #dc3545;
  background-color: #fdf3f4;
}

.form-control-custom.is-invalid:focus {
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}

.forget-password-wrapper {
  text-align: right;
  margin-top: 8px;
}

.forget-password-link {
  font-size: 0.8rem;
  font-weight: 500;
  color: #0e8937;
  text-decoration: none;
  transition: color 0.2s;
}

.forget-password-link:hover {
  color: #0a5c2c;
  text-decoration: underline;
}

/* Action Buttons styling */
.btn-premium-signin {
  position: relative;
  width: 100%;
  background: linear-gradient(135deg, #0e8937 0%, #0a5c2c 100%);
  color: #ffffff;
  border: none;
  padding: 12px;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 4px 15px rgba(14, 137, 55, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-premium-signin:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(14, 137, 55, 0.3);
  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);
  color: #050b07;
}

.separator-or {
  display: flex;
  align-items: center;
  text-align: center;
  color: #8c9c90;
  font-size: 0.8rem;
  margin: 24px 0;
}

.separator-or::before,
.separator-or::after {
  content: '';
  flex: 1;
  border-bottom: 1.5px solid #edf0f2;
}

.separator-or:not(:empty)::before {
  margin-right: 12px;
}

.separator-or:not(:empty)::after {
  margin-left: 12px;
}

.btn-camdigikey-signin {
  width: 100%;
  background: #ffffff;
  color: #0056b3;
  border: 1.5px solid #0056b3;
  padding: 11px;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.25s;
}

.btn-camdigikey-signin:hover {
  background: rgba(0, 86, 179, 0.05);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 86, 179, 0.15);
}

.btn-cam-img {
  width: 20px;
  height: auto;
  border-radius: 4px;
}

/* Animations */
.animate-bounce-subtle {
  animation: bounceSubtle 3s infinite ease-in-out;
}

@keyframes bounceSubtle {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}

/* Responsive Rules */
@media (max-width: 820px) {
  .login-card {
    flex-direction: column;
    max-width: 450px;
    border-radius: 16px;
  }
  
  .brand-panel {
    padding: 30px 20px;
  }
  
  .form-panel {
    padding: 40px 30px;
  }
}
</style>
